import React from "react";
import Container from "../ui/Container";
import SectionHeading from "../ui/SectionHeading";
import GlassCard from "../ui/GlassCard";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import { services } from "../../data/services";

const ServicesTeaser = () => (
  <section className="bg-surface-container-low py-20 md:py-section-gap">
    <Container>
      <SectionHeading
        title="Our Services"
        subtitle="A comprehensive range of logistics solutions — all in one place."
        className="mb-16"
      />
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {services.map((service) => (
          <GlassCard key={service.id} className="flex flex-col p-8">
            <Icon
              name={service.icon}
              fill
              className="mb-4 text-4xl text-primary-container"
            />
            <h3 className="mb-3 font-headline-lg text-xl text-primary">
              {service.title}
            </h3>
            <p className="mb-6 flex-grow font-body-md text-body-md text-on-surface-variant">
              {service.description}
            </p>
            {service.to ? (
              <Button to={service.to} variant="ghost" className="self-start">
                Explore
                <Icon name="arrow_forward" className="text-lg" />
              </Button>
            ) : (
              <Button to="/contact" variant="ghost" className="self-start">
                Get a quote
                <Icon name="arrow_forward" className="text-lg" />
              </Button>
            )}
          </GlassCard>
        ))}
      </div>
    </Container>
  </section>
);

export default ServicesTeaser;
